import CircleProgress from './CircleProgress';
import LineProgress from './LineProgress';
const __script_base__ = {
  name: 'UcProgress',
  model: {
    prop: 'percentage'
  },
  components: {
    CircleProgress,
    LineProgress
  },
  props: {
    percentage: {
      type: [String, Number],
      default: '70'
    },
    color: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'line'
    },
    text: {
      type: String,
      default: ''
    },
    lineWidth: {
      type: Number,
      default: 6
    }
  },
  computed: {
    defaultText() {
      if (this.percentage && !isNaN(this.percentage)) return this.text ? this.text : `${this.percentage}%`;
      return '0%';
    },
    finalText() {
      return (this.text || this.defaultText).trim();
    },
    percentSantiy() {
      if (this.percentage && !isNaN(this.percentage)) {
        return Math.min(100, Math.max(0, parseFloat(this.percentage, 10))).toString();
      }
      return '0';
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.type === 'line' ? _c('LineProgress', {
    attrs: {
      "percentage": _vm.percentage,
      "color": _vm.color,
      "line-width": _vm.lineWidth,
      "text": _vm.finalText,
      "percent-santiy": _vm.percentSantiy
    }
  }) : _c('CircleProgress', {
    attrs: {
      "type": _vm.type,
      "percentage": _vm.percentage,
      "color": _vm.color,
      "line-width": _vm.lineWidth,
      "text": _vm.finalText,
      "percent-santiy": _vm.percentSantiy
    }
  });
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Progress/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);